import * as $ from "jquery";
import * as _ from "lodash";
import * as React from "react";
import { IPlanActivity } from "../../models/LCPlanClientModels";
import { IWorkoutTagCatalogueResponse } from "../../models/maverick/IWorkoutTagCatalogueResponse";
import ModelFactory from "../../models/ModelFactory";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import { AppConstants, AppPlaceholders } from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import DurationComponent from "../DurationComponent";
import TextAreaAutoResize from "../TextAreaAutoResize";
import TextInput from "../TextInput";
import TypeAhead, {TypeAheadElement, TypeAheadResults } from "../TypeAhead";
import { ChangeEvent } from "react" 

/**
 * Created by aditya on 28/06/18.
 */

export interface FitnessPlanItemEditorProps {
    consultationType?: string,
    item: IPlanActivity;
    onDataChange: (update: any) => any,
    fetchFitnessActivities?: (input: string) => Promise<IWorkoutTagCatalogueResponse[]>;
}

export interface FitnessPlanItemEditorState {
    validate: boolean;
}

class FitnessPlanItemEditor extends React.Component<FitnessPlanItemEditorProps, FitnessPlanItemEditorState> {
    private fitnessPlanItemDOM: any;

    constructor(props: FitnessPlanItemEditorProps) {
        super(props);
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.fitnessPlanItemDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.fitnessPlanItemDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onFitnessGuidelinesChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let updatedItem = { ...this.props.item, advice: event.target.value };
        this.props.onDataChange(updatedItem);
    };

    onFitnessPlanReminderChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, reminder: event.target.checked }
        this.props.onDataChange(updatedItem);
    }

    generateFrequencyListItems() {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        })
        return frequencyList;
    }

    onFitnessActivityTypeAheadChange = (input: string) => {
        let typeAheadResults: TypeAheadResults;
        let typeAheadArray: TypeAheadElement[] = [];
        let workoutType = { displayValue: input };
        let updatedItem = { ...this.props.item, activity: workoutType };
        this.props.onDataChange(updatedItem);
        return this.props.fetchFitnessActivities(input).then((results: IWorkoutTagCatalogueResponse[]): Promise<TypeAheadResults> => {
            if (results.length) {
                _.map(results, (workoutActivity) => {
                    let typeAheadElement = {
                        value: workoutActivity.internalValue,
                        label: workoutActivity.displayValue,
                        others: {
                            sourceKind: workoutActivity.sourceKind
                        }
                    }
                    typeAheadArray.push(typeAheadElement);
                })
                typeAheadResults = {options: typeAheadArray, completed: true};
                return Promise.resolve(typeAheadResults);
            } else {
                return Promise.resolve({options: [], completed: false});
            }
        }).catch((error: any) => {
            throw error;
        });
    };

    onFitnessActivityTypeAheadSelect = (elem: TypeAheadElement) => {
        let workout = { displayValue: elem.label, internalValue: elem.value };
        let updatedItem = { ...this.props.item, activity: workout };
        this.props.onDataChange(updatedItem);
    };

    onFitnessActivityFrequencyChange = (elem: TypeAheadElement) => {
        let fitnessActivityFrequency = { ...elem.others.value };
        let updatedItem = { ...this.props.item, frequency: fitnessActivityFrequency };
        this.props.onDataChange(updatedItem);
    }

    onFitnessActivityDurationChange = (evt: any) => {
        let timeInMinutes = parseInt(evt.target.value);
        if (!isNaN(timeInMinutes) || evt.target.value === "") {
            // let fitnessActivity = { ...this.props.item.activities[0], duration: evt.target.value === "" ? "" : timeInMinutes * 60 };
            let updatedItem = { ...this.props.item, duration: timeInMinutes };
            this.props.onDataChange(updatedItem);
        }
    }

    isValidFitnessName = () => {
        let workoutTypes = this.props.item && !_.isEmpty(this.props.item.activities) ? this.props.item.activities[0].workoutTypes : [];
        let workoutCategories = this.props.item && !_.isEmpty(this.props.item.activities) ? this.props.item.activities[0].workoutCategories : [];
        let status = false;
        if ((!_.isEmpty(workoutTypes) && !_.isEmpty(workoutTypes[0].internalValue)) ||
            (!_.isEmpty(workoutCategories) && !_.isEmpty(workoutCategories[0].internalValue))) {
            status = true;
        }
        return status;
    }

    render() {
        const hasItem = !_.isEmpty(this.props.item);
        let name = hasItem && !_.isEmpty(this.props.item.activity) ? this.props.item.activity.displayValue : "";
        const hasItemfrequency = hasItem && !_.isEmpty(this.props.item.frequency);
        let frequencyUnit = hasItemfrequency ? this.props.item.frequency.unit : null;
        let frequencyCount = hasItemfrequency ? this.props.item.frequency.count : null;
        let activityDuration = hasItem && AppUtils.isDefined(this.props.item.duration) ? this.props.item.duration : null;
        let advice = hasItem && !_.isEmpty(this.props.item.advice) ? this.props.item.advice : "" as any;
        let reminder = hasItem && this.props.item.reminder;
        // let fitnessNameValidationStatus = this.state.validate && !this.isValidFitnessName() ? "error" : "";
        // let fitnessFrequencyValidationStatus = this.state.validate && _.isEmpty(frequencyUnit) && _.isNull(frequencyCount) ? "error" : "";
        // let fitnessDurationValidationStatus = this.state.validate && _.isNull(activityDuration) ? "error" : "";
        // const hasExpired = AppUtils.isExpiredPLI(this.props.item);
        // const expiredCls = hasExpired ? "expired-item" : "";
        return (
            <div className={`fitness-plan-item-editor`} ref={(fitnessPlanItemDOM) => this.fitnessPlanItemDOM = fitnessPlanItemDOM}>
                {/*{hasExpired && <div className={"expired-text"}>*/}
                    {/*<span>EXPIRED</span>*/}
                {/*</div>}*/}
                <div className={`smart-column fitness-plan-item-editor-activity`}>
                    <TypeAhead widgetName={"FitnessPlanItem"} name={"fitness-activity-name"} value={name || ""} placeholder={AppPlaceholders.FITNESS_PLAN_ACTIVITY} onTypeAheadChange={this.onFitnessActivityTypeAheadChange} onTypeAheadSelect={this.onFitnessActivityTypeAheadSelect}/>
                </div>
                <div className={`smart-column fitness-plan-item-editor-frequency`}>
                    <DurationComponent isFrequency={true} unit={frequencyUnit}
                                       count={frequencyCount} dropdownItems={this.generateFrequencyListItems()} rootClass={"fitness-plan-frequency"}
                                       onDurationChange={this.onFitnessActivityFrequencyChange} />
                </div>
                <div className={`smart-column fitness-plan-item-editor-duration`}>
                    <TextInput name={"workout-preference-duration"} onChange={this.onFitnessActivityDurationChange} value={activityDuration} />
                    <span className={"unit-label"}>mins</span>
                </div>
                <div className="smart-column fitness-plan-item-editor-advice">
                    <TextAreaAutoResize
                        name={"fitness-plan-item-editor-advice"}
                        className={"textarea-input form-control"}
                        value={advice}
                        placeholder={AppPlaceholders.FITNESS_PLAN_ADVICE}
                        onChange={this.onFitnessGuidelinesChange}
                        rows={2}
                    />
                </div>
                <div className="smart-column fitness-plan-item-editor-reminder">
                    <input type="checkbox" onChange={this.onFitnessPlanReminderChange} checked={reminder} />
                </div>
            </div>
        )
    }
}

export default FitnessPlanItemEditor;
